import tokensCss from '@/ui/estilos/tokens.css?raw';
import { lerBloco, paraRgb255, type Rgb } from '@/ui/estilos/lerTokens';

/**
 * Cor institucional dos PDFs gerados no navegador (jsPDF), em RGB 0..255.
 *
 * O jsPDF desenha direto no arquivo e nao enxerga variavel CSS, entao a cor
 * nao pode vir de `var(--primary)`. Ela e DERIVADA do token `--primary` do
 * `:root` de tokens.css (regra de interface 2: cor sempre por token), lido em
 * tempo de build (`?raw`). Mudou o token, mudou o cabecalho de todo PDF, sem
 * ninguem lembrar de trocar um literal por exportador.
 *
 * O token e o do tema CLARO de proposito: PDF e papel, nao segue o tema da tela.
 */
function lerPrimaria(): Rgb {
  const primaria = lerBloco(tokensCss, ':root').get('primary');
  if (!primaria) {
    throw new Error('Token --primary nao encontrado no :root de tokens.css');
  }
  return paraRgb255(primaria);
}

export const COR_PRIMARIA_PDF: Rgb = lerPrimaria();
